import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=3212153b&scoped=true"
import script from "./PopupDialog.vue?vue&type=script&lang=js"
export * from "./PopupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3212153b",
  null
  
)

export default component.exports